// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%275%27 viewBox=%270 0 8 4%27%3E%3Cpath d=%27M4 4L0.535899 0.25L7.4641 0.25L4 4Z%27 fill=%27%23102C98%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardClient {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  overflow: auto;
  position: relative;
}
.DashboardClient .SelectContainer {
  height: 1.75rem;
  width: 100%;
  display: flex;
  align-self: flex-start;
  justify-content: space-between;
}
.DashboardClient .SelectContainer select {
  width: 10rem;
  border: 0.0625rem solid var(--Stroke);
  background: var(--Foreground);
  border-radius: 0.375rem;
  padding: 0 0.75rem;
  color: var(--TextColor);
}
.DashboardClient .VendorStatsWrapper {
  flex: 1 1;
  width: 100%;
  overflow: auto;
}
.DashboardClient .VendorAmount {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.25rem;
}
.DashboardClient .Table {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}
.DashboardClient .Table .Back {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 3rem;
}
.DashboardClient .Table .Back svg, .DashboardClient .Table .Back span {
  cursor: pointer;
  margin-left: 0.25rem;
  color: var(--AccentColor);
}
.DashboardClient .Table .Back svg path {
  fill: var(--AccentColor);
}
.DashboardClient .Table .TableContainer {
  flex: 1 1;
  width: 100%;
  overflow: auto;
}
.DashboardClient .Table .TableContainer table {
  width: 100%;
  white-space: nowrap;
  text-align: left;
  border-collapse: collapse;
  overflow: auto;
  font-size: 0.875rem;
  border-radius: 0.5rem;
}
.DashboardClient .Table .TableContainer table thead {
  height: 2.5rem;
  z-index: 2;
  position: sticky;
  top: 0;
  border-radius: 0.5rem 0.5rem 0 0;
}
.DashboardClient .Table .TableContainer table thead tr {
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom: 0.375rem solid var(--Hover);
}
.DashboardClient .Table .TableContainer table thead tr th {
  height: 2.5rem;
  padding: 0 0.75rem;
  max-width: 12.5rem;
  color: var(--AccentColor);
  background: var(--Foreground);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.DashboardClient .Table .TableContainer table thead tr th:nth-child(1) {
  border-radius: 0.5rem 0 0 0;
}
.DashboardClient .Table .TableContainer table thead tr th:last-child {
  position: sticky;
  top: 0;
  right: 0;
  border-radius: 0 0.5rem 0 0;
  min-width: 10rem;
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-left: 0.375rem solid var(--Hover);
}
.DashboardClient .Table .TableContainer table tbody tr {
  height: 2.5rem;
  background: var(--Foreground);
  position: relative;
}
.DashboardClient .Table .TableContainer table tbody tr td {
  padding: 0 0.75rem;
  max-width: 12.5rem;
  color: var(--TextColor);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.DashboardClient .Table .TableContainer table tbody tr .NameReport {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  font-weight: 600;
  color: var(--TextColor);
}
.DashboardClient .Table .TableContainer table tbody tr .Actions {
  position: sticky;
  right: 0;
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  background: var(--Foreground);
  min-width: 10rem;
  border-left: 0.375rem solid var(--Hover);
  z-index: 1;
}
.DashboardClient .Table .TableContainer table tbody tr .Actions svg {
  cursor: pointer;
}
.DashboardClient .Table .TableContainer table tbody tr .Actions svg path {
  fill: var(--TextColor);
}
.DashboardClient .Table .TableContainer table tbody tr .Actions .Update {
  font-size: 0.75rem;
  color: var(--AccentColor);
  cursor: pointer;
}
.DashboardClient .Table .TableContainer table tbody tr .Actions::after {
  display: block;
  content: "";
  height: 0.25rem;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  background: var(--Background);
}
.DashboardClient .Table .TableContainer table tbody tr .status {
  padding: 0.25rem 0.625rem;
  border-radius: 1.25rem;
  text-transform: capitalize;
  font-size: 0.75rem;
  color: var(--TextColor);
  text-align: center;
}
.DashboardClient .Table .TableContainer table tbody tr .invitation {
  background: var(--Invitation);
}
.DashboardClient .Table .TableContainer table tbody tr .accepted {
  background: var(--Accepted);
}
.DashboardClient .Table .TableContainer table tbody tr .inprogress {
  background: var(--Inprogress);
}
.DashboardClient .Table .TableContainer table tbody tr .pending {
  background: var(--Pending);
}
.DashboardClient .Table .TableContainer table tbody tr .completed {
  background: var(--Completed);
}
.DashboardClient .Table .TableContainer table tbody tr .cancelled {
  background: var(--Cancelled);
}
.DashboardClient .Table .TableContainer table tbody tr .re-initiated {
  background: var(--Reinitiated);
}
.DashboardClient .Table .TableContainer table tbody tr:hover .NameReport {
  color: var(--AccentColor);
}
.DashboardClient .Table .TableContainer table tbody tr:hover td {
  background: var(--Hover);
}
.DashboardClient .Table .TableContainer table tbody tr:hover .Actions svg path {
  fill: var(--AccentColor);
}
.DashboardClient .Table .TableContainer table tbody tr:not(:last-child)::after {
  content: "";
  height: 0.25rem;
  width: calc(100% - 10rem);
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--Background);
}
.DashboardClient .Table .TableContainer table tbody tr:last-child .Actions::after {
  display: none;
}
.DashboardClient .Table .TableContainer .TableOptions {
  display: none;
  position: absolute;
  top: 5.5rem;
  right: 1rem;
  padding: 0.75rem 0.75rem 0.75rem 1rem;
  background: var(--Foreground);
  border-radius: 0.75rem;
  box-shadow: 0 0 1rem 0.5rem var(--Background);
  z-index: 4;
  max-height: calc(100% - 10rem);
  overflow: auto;
}
.DashboardClient .Table .TableContainer .TableOptions .Options {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 10rem;
  overflow: auto;
}
.DashboardClient .Table .TableContainer .TableOptions .Options label {
  width: calc(100% - 0.5rem);
  padding: 0.25rem 0.75rem;
  border: 0.125rem dashed var(--Stroke);
  color: var(--TextColor);
  font-size: 0.75rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.DashboardClient .Table .TableContainer .TableOptions .Options label input {
  width: 0.75rem;
  height: 0.75rem;
  min-width: 0.75rem;
  min-height: 0.75rem;
  accent-color: var(--AccentColor);
  background: var(--Foreground);
}
.DashboardClient .Table .TableContainer .TableOptions .ApplyCancel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem 0 0 0;
}
.DashboardClient .Table .TableContainer .TableOptions .ApplyCancel button {
  width: 4rem;
  background: var(--AccentColor);
  height: 1.5rem;
  border-radius: 0.25rem;
  color: #ffffff;
  font-size: 0.75rem;
}
.DashboardClient .Table .TableContainer .TableOptions .ApplyCancel .Cancel {
  background: #b7b7b7;
  color: #312121;
}
.DashboardClient .Table .TableContainer .ShowTableOptions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.DashboardClient .Table .PaginationContainer {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2.5rem;
  padding-right: 0.625rem;
}
.DashboardClient .Table .PaginationContainer .Pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(100% - 130px);
  height: 100%;
  gap: 0.625rem;
  padding-left: 1.25rem;
}
.DashboardClient .Table .PaginationContainer .Pagination .NextPrev {
  color: var(--AccentColor);
  background: none;
  border: none;
  font-weight: 700;
  padding: 5px 0.625rem;
}
.DashboardClient .Table .PaginationContainer .Pagination .NextPrev:hover {
  border-radius: 25px;
  background: #efefef;
}
.DashboardClient .Table .PaginationContainer .Pagination .PageNo {
  width: 25px;
  height: 25px;
  color: var(--TextColor);
  border-radius: 1.25rem;
  padding: 5px;
  background: none;
  border: none;
  font-weight: 700;
}
.DashboardClient .Table .PaginationContainer .Pagination .PageNo:hover {
  background: var(--Hover);
}
.DashboardClient .Table .PaginationContainer .Pagination .CurrentPage {
  background: #efefef;
}
.DashboardClient .Table .PaginationContainer .Pagination .disabled {
  color: #8a8a8a;
  cursor: not-allowed;
}
.DashboardClient .Table .PaginationContainer .ItemsPerPage {
  width: 122px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--AccentColor);
  background: var(--Foreground);
  border-radius: 0.5rem;
  padding-right: 5px;
}
.DashboardClient .Table .PaginationContainer .ItemsPerPage .OptionsLabel {
  color: var(--TextColor);
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0px 16px;
  border-right: 1px solid var(--AccentColor);
}
.DashboardClient .Table .PaginationContainer .ItemsPerPage .Options {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right center;
  background-size: 0.875rem;
  width: 55px;
  height: 1.25rem;
  border: none;
  font-size: 0.75rem;
  color: var(--TextColor);
  outline: none;
}
.DashboardClient .Table .PaginationContainer .ItemsPerPage .Options option {
  background-color: var(--Foreground);
  color: var(--TextColor);
  text-align: center;
}
.DashboardClient .LoaderContainer {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/ClientComponents/DashboardClient.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAEJ;AADI;EACE,YAAA;EACA,qCAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AAGN;AAAE;EACE,SAAA;EACA,WAAA;EACA,cAAA;AAEJ;AAAE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAEJ;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAEJ;AADI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAGN;AAFM;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;AAIR;AADQ;EACE,wBAAA;AAGV;AACI;EACE,SAAA;EACA,WAAA;EACA,cAAA;AACN;AACM;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AACR;AAAQ;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,MAAA;EACA,gCAAA;AAEV;AADU;EACE,gCAAA;EACA,0CAAA;AAGZ;AAFY;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAId;AAFY;EACE,2BAAA;AAId;AAFY;EACE,gBAAA;EACA,MAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;AAId;AACU;EACE,cAAA;EACA,6BAAA;EACA,kBAAA;AACZ;AAAY;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAEd;AAAY;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAEd;AAAY;EACE,gBAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;AAEd;AADc;EACE,eAAA;AAGhB;AAFgB;EACE,sBAAA;AAIlB;AADc;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;AAGhB;AAAY;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6BAAA;AAEd;AAAY;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AAEd;AAAY;EACE,6BAAA;AAEd;AAAY;EACE,2BAAA;AAEd;AAAY;EACE,6BAAA;AAEd;AAAY;EACE,0BAAA;AAEd;AAAY;EACE,4BAAA;AAEd;AAAY;EACE,4BAAA;AAEd;AAAY;EACE,8BAAA;AAEd;AAEY;EACE,yBAAA;AAAd;AAEY;EACE,wBAAA;AAAd;AAIgB;EACE,wBAAA;AAFlB;AAOU;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AALZ;AAQY;EACE,aAAA;AANd;AAWM;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,6BAAA;EACA,sBAAA;EACA,6CAAA;EACA,UAAA;EACA,8BAAA;EACA,cAAA;AATR;AAUQ;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AARV;AASU;EACE,0BAAA;EACA,wBAAA;EACA,qCAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAPZ;AAQY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,6BAAA;AANd;AAUQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AARV;AASU;EACE,WAAA;EACA,8BAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAPZ;AASU;EACE,mBAAA;EACA,cAAA;AAPZ;AAWM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AATR;AAYI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AAVN;AAWM;EACE,aAAA;EACA,mBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AAVR;AAWQ;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AATV;AAWQ;EACE,mBAAA;EACA,mBAAA;AATV;AAWQ;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AATV;AAWQ;EACE,wBAAA;AATV;AAWQ;EACE,mBAAA;AATV;AAWQ;EACE,cAAA;EACA,mBAAA;AATV;AAYM;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;AAVR;AAWQ;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;AATV;AAWQ;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0EAAA;EACA,yBAAA;EACA,WAAA;EAEA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;AAVV;AAWU;EACE,mCAAA;EACA,uBAAA;EACA,kBAAA;AATZ;AAeE;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAbJ","sourcesContent":[".DashboardClient{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  overflow: auto;\n  position: relative;\n  .SelectContainer{\n    height: 1.75rem;\n    width: 100%;\n    display: flex;\n    align-self: flex-start;\n    justify-content: space-between;\n    select{\n      width: 10rem;\n      border: 0.0625rem solid var(--Stroke);\n      background: var(--Foreground);\n      border-radius: 0.375rem;\n      padding: 0 0.75rem;\n      color: var(--TextColor);\n    }\n  }\n  .VendorStatsWrapper{\n    flex: 1;\n    width: 100%;\n    overflow: auto;\n  }\n  .VendorAmount{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1.25rem;\n  }\n  .Table{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: auto;\n    .Back{\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      height: 3rem;\n      svg, span{\n        cursor: pointer;\n        margin-left: 0.25rem;\n        color: var(--AccentColor);\n      }\n      svg{\n        path{\n          fill: var(--AccentColor);\n        }\n      }\n    }\n    .TableContainer{\n      flex: 1;\n      width: 100%;\n      overflow: auto;\n      // position: relative;\n      table{\n        width: 100%;\n        white-space: nowrap;\n        text-align: left;\n        border-collapse: collapse;\n        overflow: auto;\n        font-size: 0.875rem;\n        border-radius: 0.5rem;\n        thead{\n          height: 2.5rem;\n          z-index: 2;\n          position: sticky;\n          top: 0;\n          border-radius: 0.5rem 0.5rem 0 0;\n          tr{\n            border-radius: 0.5rem 0.5rem 0 0;\n            border-bottom: 0.375rem solid var(--Hover);\n            th{\n              height: 2.5rem;\n              padding: 0 0.75rem;\n              max-width: 12.5rem;\n              color: var(--AccentColor);\n              background: var(--Foreground);\n              overflow: hidden;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n            }\n            th:nth-child(1){\n              border-radius: 0.5rem 0 0 0;\n            }\n            th:last-child{\n              position: sticky;\n              top: 0;\n              right: 0;\n              border-radius: 0 0.5rem 0 0;\n              min-width: 10rem;\n              height: 2.5rem;\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              justify-content: space-between;\n              border-left: 0.375rem solid var(--Hover);\n            }\n          }\n        }\n        tbody{\n          tr{\n            height: 2.5rem;\n            background: var(--Foreground);\n            position: relative;\n            td{\n              padding: 0 0.75rem;\n              max-width: 12.5rem;\n              color: var(--TextColor);\n              overflow: hidden;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n            }\n            .NameReport{\n              overflow: hidden;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n              cursor: pointer;\n              font-weight: 600;\n              color: var(--TextColor);\n            }\n            .Actions{\n              position: sticky;\n              right: 0;\n              height: 2.5rem;\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              gap: 0.75rem;\n              background: var(--Foreground);\n              min-width: 10rem;\n              border-left: 0.375rem solid var(--Hover);\n              z-index: 1;\n              svg{\n                cursor: pointer;\n                path{\n                  fill: var(--TextColor);\n                }\n              }\n              .Update{\n                font-size: 0.75rem;\n                color: var(--AccentColor);\n                cursor: pointer;\n              }\n            }\n            .Actions::after{\n              display: block;\n              content: '';\n              height: 0.25rem;\n              width: 100%;\n              position: absolute;\n              bottom: 0;\n              right: 0;\n              background: var(--Background);\n            }\n            .status{\n              padding: 0.25rem 0.625rem;\n              border-radius: 1.25rem;\n              text-transform: capitalize;\n              font-size: 0.75rem;\n              color: var(--TextColor);\n              text-align: center;\n            }\n            .invitation{\n              background: var(--Invitation);\n            }\n            .accepted{\n              background: var(--Accepted);\n            }\n            .inprogress{\n              background: var(--Inprogress);\n            }\n            .pending{\n              background: var(--Pending);\n            }\n            .completed{\n              background: var(--Completed);\n            }\n            .cancelled{\n              background: var(--Cancelled);\n            }\n            .re-initiated{\n              background: var(--Reinitiated);\n            }\n          }\n          tr:hover{\n            .NameReport{\n              color: var(--AccentColor);\n            }\n            td{\n              background: var(--Hover);\n            }\n            .Actions{\n              svg{\n                path{\n                  fill: var(--AccentColor);\n                }\n              }\n            }\n          }\n          tr:not(:last-child)::after{\n            content: '';\n            height: 0.25rem;\n            width: calc(100% - 10rem);\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            background: var(--Background);\n          }\n          tr:last-child{\n            .Actions::after{\n              display: none;\n            }\n          }\n        }\n      }\n      .TableOptions{\n        display: none;\n        position: absolute;\n        top: 5.5rem;\n        right: 1rem;\n        padding: 0.75rem 0.75rem 0.75rem 1rem;\n        background: var(--Foreground);\n        border-radius: 0.75rem;\n        box-shadow: 0 0 1rem 0.5rem var(--Background);\n        z-index: 4;\n        max-height: calc(100% - 10rem);\n        overflow: auto;\n        .Options{\n          flex: 1;\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          gap: 0.5rem;\n          width: 10rem;\n          overflow: auto;\n          label{\n            width: calc(100% - 0.5rem);\n            padding: 0.25rem 0.75rem;\n            border: 0.125rem dashed var(--Stroke);\n            color: var(--TextColor);\n            font-size: 0.75rem;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            input{\n              width: 0.75rem;\n              height: 0.75rem;\n              min-width: 0.75rem;\n              min-height: 0.75rem;\n              accent-color: var(--AccentColor);\n              background: var(--Foreground);\n            }\n          }\n        }\n        .ApplyCancel{\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 0.75rem;\n          padding: 0.75rem 0 0 0;\n          button{\n            width: 4rem;\n            background: var(--AccentColor);\n            height: 1.5rem;\n            border-radius: 0.25rem;\n            color: #ffffff;\n            font-size: 0.75rem;\n          }\n          .Cancel{\n            background: #b7b7b7;\n            color: #312121;\n          }\n        }\n      }\n      .ShowTableOptions{\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n      }\n    }\n    .PaginationContainer{\n      height: 50px;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      gap: 2.5rem;\n      padding-right: 0.625rem;\n      .Pagination{\n        display: flex;\n        flex-direction: row;\n        // justify-content: space-between;\n        align-items: center;\n        width: calc(100% - 130px);\n        height: 100%;\n        gap: 0.625rem;\n        padding-left: 1.25rem;\n        .NextPrev{\n          color: var(--AccentColor);\n          background: none;\n          border: none;\n          font-weight: 700;\n          padding: 5px 0.625rem;\n        }\n        .NextPrev:hover{\n          border-radius: 25px;\n          background: #efefef;\n        }\n        .PageNo{\n          width: 25px;\n          height: 25px;\n          color: var(--TextColor);\n          border-radius: 1.25rem;\n          padding: 5px;\n          background: none;\n          border: none;\n          font-weight: 700;\n        }\n        .PageNo:hover{\n          background: var(--Hover);\n        }\n        .CurrentPage{\n          background: #efefef;\n        }\n        .disabled{\n          color: #8a8a8a;\n          cursor: not-allowed;\n        }\n      }\n      .ItemsPerPage{\n        width: 122px;\n        height: 30px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        border: 1px solid var(--AccentColor);\n        background: var(--Foreground);\n        border-radius: 0.5rem;\n        padding-right: 5px;\n        .OptionsLabel{\n          color: var(--TextColor);\n          font-size: 0.75rem;\n          font-weight: 500;\n          padding: 0px 16px;\n          border-right: 1px solid var(--AccentColor);\n        }\n        .Options{\n          appearance: none;\n          -webkit-appearance: none;\n          -moz-appearance: none;\n          background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='5' viewBox='0 0 8 4'%3E%3Cpath d='M4 4L0.535899 0.25L7.4641 0.25L4 4Z' fill='%23102C98'/%3E%3C/svg%3E\") no-repeat right center;\n          background-size: 0.875rem;\n          width: 55px;\n          // padding-left: 0.625rem;\n          height: 1.25rem;\n          border: none;\n          font-size: 0.75rem;\n          color: var(--TextColor);\n          outline: none;\n          option{\n            background-color: var(--Foreground);\n            color: var(--TextColor);\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n  .LoaderContainer{\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2C2C2C50;\n    z-index: 3;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
